import { render, staticRenderFns } from "./CrmSpecialist.vue?vue&type=template&id=0744c595&scoped=true"
import script from "./CrmSpecialist.vue?vue&type=script&lang=js"
export * from "./CrmSpecialist.vue?vue&type=script&lang=js"
import style0 from "./CrmSpecialist.vue?vue&type=style&index=0&id=0744c595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0744c595",
  null
  
)

export default component.exports